export default __webpack_public_path__ + "static/media/lapras-box-narrow.30e19c21.png";